import client from './client';

/**
 * Admin service-order lookups (2020PH/NV payroll editor — the Hourly modal's
 * Service Order mode). Mirrors API `GET admin/serviceOrders/typeahead` and
 * `GET admin/serviceOrders/:id` (admin token). 2020 service orders are synced
 * from Sage; `name` is always null there, so callers display the SO as
 * `SO {altServiceOrderID} · {altProjectID} {projectName}`.
 *
 * No `_createAlert` here: the picker and the modal own their empty / not-in-sync
 * states, so a global alert on top would be a second copy of the same message.
 */

export interface AdminServiceOrderAccountCode {
  accountCodeID: number;
  altAccountCodeID: string;
  name: string;
}

export interface AdminServiceOrderLookup {
  serviceOrderID: number;
  altServiceOrderID: string;
  name: string | null;
  projectID: number | null;
  altProjectID: string | null;
  projectName: string | null;
  projectActive: boolean;
  isActive: boolean;
  /** Only on `GET admin/serviceOrders/:id` — the codes across the SO project's phases. */
  accountCodes?: AdminServiceOrderAccountCode[];
}

export default class ServiceOrdersAPI {
  static async typeahead(q: string, limit = 25): Promise<AdminServiceOrderLookup[]> {
    const response = await client.get<AdminServiceOrderLookup[]>('admin/serviceOrders/typeahead', {
      params: { q, limit },
    });
    return response.data ?? [];
  }

  static async getServiceOrder(serviceOrderID: number): Promise<AdminServiceOrderLookup> {
    const response = await client.get<AdminServiceOrderLookup>(`admin/serviceOrders/${serviceOrderID}`);
    return response.data;
  }
}
